import { useTranslation } from "react-i18next";
import ListPage from "../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";

const GroupList = () => {

    const { t } = useTranslation();
    return (
        <ListPage
            showPageTitle="true"
            activeMenu={t("groups")}
            motherMenu={t("identity")}
            path={Api.identity.group}
            route={MenuConfig.identity.group.route}
            columns={Columns}
        />
    );
}

export default GroupList;